import { useFeatureGate } from '@statsig/react-bindings';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { StatsigLoadingContext } from '../../statsig/StatsigProvider';
import { clientUserAuthGate, preSessionReflectionsGate } from '../../statsig/gates';
import { useGetReflectionTopicCountQuery } from './useGetReflectionTopicCountQuery';

export function useGetShouldShowReflectionTopics() {
  const { patientShortId } = useParams();
  const { value: isPreSessionReflectionsEnabled } = useFeatureGate(preSessionReflectionsGate);
  const { value: isClientUserAuthEnabled } = useFeatureGate(clientUserAuthGate);
  const { data: reflectionTopicCount, loading: reflectionTopicCountLoading } = useGetReflectionTopicCountQuery(
    patientShortId ?? '',
  );
  const isStatsigLoading = useContext(StatsigLoadingContext);
  const isLoading = isStatsigLoading || reflectionTopicCountLoading;
  const shouldShowReflectionTopics =
    isPreSessionReflectionsEnabled &&
    isClientUserAuthEnabled &&
    reflectionTopicCount?.patient.reflectionTopics.totalCount > 0;
  return {
    shouldShowReflectionTopics,
    isLoading,
  };
}
